// --- USER PREFRENCES
// column visibility
export const AFFILIATE_FINDER_COLUMNS_KEY = 'af-columns-visibility';
export const COLLABORATION_REVIEW_COLUMNS_KEY = 'cr-column-visibility';
export const MY_COMMUNITY_COLUMNS_KEY = 'mc-columns-visibility';

// table pagination
export const AFFILIATE_FINDER_PAGINATION_KEY = 'af-pagination';
export const COLLABORATION_REVIEW_PAGINATION_KEY = 'cr-pagination';
export const MY_COMMUNITY_PAGINATION_KEY = 'mc-pagination';

// permissions
export const TTS_BUSINESS_API_ALERT_SKIPPED_KEY = 'tts-business-api-alert-skipped';
